<script>
import Layout from "../../layouts/main";
import OrdersTab from "@/router/views/orders/ordersTab";
import InvoicesTab from "@/router/views/invoices/invoicesList"
import AvoirsTab from "@/router/views/invoices/AvoirsList"
import InvoicesFinancialTab from "@/router/views/invoices/invoicesFinancialList"
import ReservationTab from "@/router/views/orders/cartsTab"
import OrdersApi from "@/services/orders-api";
import InvoicesApi from "@/services/invoices-api";
import BackOrdersApi from "@/services/backOrders-api";
import {Priviliges} from "../../../privileges";
//import UsersApi from "@/services/users-api";

/**
 * Orders-list component
 */
export default {

  mounted(){

    this.role=sessionStorage.getItem("userr");

    /*if (this.role == 0) {
        UsersApi.isSuperClient().then(
            result => {
                this.isSuperClient=result;
            })
    } else {
        this.isSuperClient = true;
    }*/
    this.isSuperClient = this.role == 0 ? false : true;

      if(sessionStorage.getItem("privileges")!=null){
            this.privileges=sessionStorage.getItem("privileges")
            this.isAdmin=this.privileges.includes(Priviliges[0]["Admin_Role"] )
            this.hasOrdersListAccess= this.privileges.includes(Priviliges[0]["OrderList_Access"] )
            this.hasBackOrdersListAccess=this.privileges.includes(Priviliges[0]["BackOrder_Access"] )
            this.hasInvoicesListAccess=this.privileges.includes(Priviliges[0]["InvoicesList_Access"] )
            this.isCustomer= this.privileges.includes(Priviliges[0]["Customer_Role"] )
            this.hasCatalogAccess=this.privileges.includes(Priviliges[0]["Catalog_Access"] ) 

      }
      if(this.isAdmin || this.isCustomer || this.hasBackOrdersListAccess){
        this.countBackOrders()
      }
      if(this.isAdmin || this.isCustomer || this.hasOrdersListAccess || this.hasCatalogAccess){
        this.countOrders()
      }
      if(this.isAdmin || this.isCustomer || this.hasInvoicesListAccess){
        this.countInvoices()
      }
      
      
  },

  components: {Layout,OrdersTab,InvoicesTab,ReservationTab, InvoicesFinancialTab, AvoirsTab },
  data() {
    return {
        role: null, 
        backOrdersCount:0,
        ordersCount:0,
        invoicesCount:0,
        privileges:"", 
        hasOrdersListAccess:false,
        hasBackOrdersListAccess:false,
        hasInvoicesListAccess:false,
        hasInvoicesFinancialListAccess: false,
        hasAvoirListAccess: false,
        isAdmin:false,
        isCustomer:false,
        hasCatalogAccess:false,

        isSuperClient: false,
    };
  }, 

    methods: {
        countBackOrders(){
            BackOrdersApi.getBackOrdersCount().then(
                (result)=>{
                    if(result){
                        this.backOrdersCount=result
                    }else{
                        this.backOrdersCount=0
                    }
                    
                }
            )
        },
        countOrders(){
            OrdersApi.getOrdersCount(null).then(
                (result)=>{
                    if(result){
                        this.ordersCount=result
                    }else{
                        this.ordersCount=0

                    }
                }
            )
        },
        countInvoices(){
            InvoicesApi.getInvoicesCount(null).then(
                (result)=>{
                    if(result){
                        this.invoicesCount=result
                    }else{
                        this.invoicesCount=0
                    }
                }
            )
        },
    }       
    }

</script>
<template>
<Layout>
    <div class="row p-4">
        <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
                <h2 class="card-title font-size-25" style="font-size:25px;">{{$t('ordersMenu.bigTitle')}}</h2>
                <p class="card-title-desc font-size-14">
                    <u class="mr-1"><span >{{this.backOrdersCount}}</span>  &nbsp;{{$t('cartTab.title')}},</u> &nbsp;&nbsp;
                    <u class="mr-1"><span>{{this.ordersCount}}</span>  &nbsp;{{$t('ordersMenu.title')}},</u> &nbsp;&nbsp;
                    <u class="mr-1"><span>{{this.invoicesCount}}</span> Bons de Livraisons.</u>
                </p>
                <b-tabs nav-class="nav-tabs-custom" content-class="p-0 text-muted" active-nav-item-class="font-weight-bold text-uppercase ">
                <b-tab v-if="isCustomer || isAdmin || hasBackOrdersListAccess"   lazy>
                    <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="fas fa-bookmark font-size-16"></i>
                    </span>
                    <i class="d-none d-sm-inline-block fas fa-bookmark font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">{{$t('cartTab.title')}}</span>
                    </template>
                    <ReservationTab class="mt-4"/>
                </b-tab>
                <b-tab v-if="isCustomer || isAdmin || hasOrdersListAccess || hasCatalogAccess" active lazy>
                    <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="fas fa-cart-plus font-size-16"></i>
                    </span>
                    <i class="d-none d-sm-inline-block fas fa-cart-plus font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">{{$t('ordersMenu.title')}}</span>
                    </template>
                    <OrdersTab/>
                </b-tab>
                <b-tab v-if="isCustomer || isAdmin || hasInvoicesListAccess" lazy>
                    <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="fas fa-truck-loading font-size-16"></i>
                    </span>
                    <i class="d-none d-sm-inline-block fas fa-truck-loading font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">Bons de Livraisons</span>
                    </template>
                    <InvoicesTab class="mt-4"/>
                </b-tab>


                <b-tab v-if="(isCustomer || isAdmin || hasInvoicesFinancialListAccess) " lazy>
                    <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="fas fa-file-invoice-dollar font-size-16"></i>
                    </span>
                    <i class="d-none d-sm-inline-block fas fa-file-invoice-dollar font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">Factures</span>
                    </template>
                    <InvoicesFinancialTab class="mt-4"/>
                </b-tab>

                <b-tab v-if="(isCustomer || isAdmin || hasInvoicesFinancialListAccess)" lazy>
                    <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="fas fa-file-alt font-size-16"></i>
                    </span>
                    <i class="d-none d-sm-inline-block fas fa-file-alt font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">Avoirs</span>
                    </template>
                    <AvoirsTab class="mt-4"/>
                </b-tab>


                </b-tabs>
            </div>
        </div>
      </div>
    </div>
</Layout>
</template>